import * as React from 'react';
import styled from '@emotion/styled';

interface PropsType {
    className?: string;
}

const SvgWrapper = styled('svg', { label: 'SvgWrapper' })<PropsType>`
    height: auto;
`;

export const ArrowUpIcon = ({ className }: PropsType): React.ReactElement => (
    <SvgWrapper
        width={10}
        height={10}
        fill='#fff'
        className={className}
        viewBox='0 0 10 10'
        xmlSpace='preserve'
    >
        <path
            fill='#fill'
            fillRule='nonzero'
            d='M5 0h.02c.023 0 .046.002.07.004l.059.007.052.01a.762.762 0 01.065.015l.046.014.06.021.051.023.061.03.037.022a.939.939 0 01.186.147l-.09-.08.008.007.082.073 4 4a1 1 0 01-1.414 1.414L6 3.414V9a1 1 0 01-.883.993L5 10a1 1 0 01-1-1V3.414L1.707 5.707a1 1 0 01-1.32.083l-.094-.083a1 1 0 010-1.414l4-4L4.375.22l.008-.007.022-.017c.024-.018.049-.034.074-.05l.037-.021c.02-.011.04-.022.06-.031l.053-.023.06-.021.045-.014.065-.016.053-.009A1.02 1.02 0 015 0l-.09.004L4.983 0z'
        />
    </SvgWrapper>
);
